"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectMetadataForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _constants = require("@/util/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SelectMetadataForm = exports.SelectMetadataForm = function SelectMetadataForm(_ref) {
  var internalFiles = _ref.internalFiles,
    fileCategoryValue = _ref.fileCategoryValue,
    setInternalFiles = _ref.setInternalFiles,
    metadataValue = _ref.metadataValue;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-details flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "title",
    style: {
      fontSize: "16px"
    }
  }, "Details"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: "14px",
      marginTop: "10px"
    }
  }, "Provide the file details."), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "red"
    }
  }, "*"), "Indicates required")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      marginTop: "20px",
      rowGap: "20px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "red"
    }
  }, "*"), "File category"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    color: "success",
    select: true,
    label: "Select",
    name: "fileCategory",
    disabled: internalFiles.filter(function (iF) {
      return iF.isChecked;
    }).length === 0,
    value: fileCategoryValue,
    onChange: function onChange(e) {
      setInternalFiles(function (prev) {
        return prev.map(function (f) {
          return f.isChecked ? _objectSpread(_objectSpread({}, f), {}, {
            fileCategory: e.target.value,
            isCompleted: true
          }) : f;
        });
      });
    },
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    size: "small",
    inputProps: {
      "data-testid": "categorySelector"
    }
  }, _constants.CATEGORIES.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Metadata"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    color: "success",
    label: "Type",
    name: "metadata",
    disabled: internalFiles.filter(function (iF) {
      return iF.isChecked;
    }).length === 0,
    value: metadataValue,
    onChange: function onChange(e) {
      if (e.target.value.length <= _constants.MAX_METADATA_LENGTH) {
        setInternalFiles(function (prev) {
          return prev.map(function (f) {
            return f.isChecked ? _objectSpread(_objectSpread({}, f), {}, {
              metadata: e.target.value
            }) : f;
          });
        });
      }
    },
    fullWidth: true,
    multiline: true,
    rows: 4,
    margin: "normal",
    variant: "outlined",
    inputProps: {
      "data-testid": "metadataField"
    },
    placeholder: "Metadata improves AI search by adding context with keywords and descriptions, making search results more relevant and responses better."
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text_counter_container"
  }, metadataValue === null || metadataValue === void 0 ? void 0 : metadataValue.length, " / ", _constants.MAX_METADATA_LENGTH))));
};